<template>
    <div class="privacy-agreement">
      <tHeader ref="head" @getTitle="getTitle" :title="title"></tHeader>
      <div class="content">
        <div class="list" v-for="item in $t('privacyAgreement.contents')" :key="item.id">
          <template v-if="item.contentArr">
            <p v-for="(content, index) in item.contentArr" :key='index'>{{content}}</p>
          </template>
          <template v-if="!item.contentArr">
            <p v-html="item.content"></p>
          </template>
        </div>
      </div>
    </div>
</template>

<script>
import tHeader from './theader'
export default {
  name: 'privacy-agreement',
  data () {
    return {
      title: ''
    }
  },
  components: {
    tHeader
  },
  created () {
    this.getTitle()
  },
  methods: {
    fatherMethod () {
      this.$refs.head.changeLanguage()
    },
    getTitle () {
      this.title = this.$t('privacyAgreement.title')
    }
  }
}
</script>

<style scoped lang="stylus">
.privacy-agreement{
  .content{
    padding: 18px 12px;
    .list{
      margin-bottom: 30px;
      p{
        font-size: 14px;
        line-height: 22px;
        color: #333;
        text-align: left;
      }
    }
  }
}
</style>
